<template>
  <div class="password-change">
    <header-mobile-page label="Change Password" />
    <password-change />
  </div>
</template>

<script>
  import PasswordChange from '@/components/Common/PasswordChange/PasswordChange.vue'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      PasswordChange,
      HeaderMobilePage
    }
  }
</script>

<style lang="scss" scoped>
  .password-change {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;
  }
</style>